define([ // START Open Requre.JS wrapper
	'jquery',
	'pubsub',
], function($) {
	
	"use strict";
	
	var updateQueryStringParameter = function(uri, key, value, addIfNotPresent, addAsHash) {
		var re = new RegExp('([?&#])' + key + '=.*?(&|#|$)', 'i'),
			hash =  '',
			separator = '';

		if (uri.match(re)) {
			return uri.replace(re, '$1' + key + '=' + value + '$2');
		}
		// No matches
		if(addIfNotPresent) {
			if(addAsHash) {
				separator = uri.indexOf('#') !== -1 ? '&' : '#';
			} else {
				separator = uri.indexOf('?') !== -1 ? '&' : '?';
				if( uri.indexOf('#') !== -1 ){
					hash = uri.replace(/.*#/, '#');
					uri = uri.replace(/#.*/, '');
				}
			}
			return uri + separator + key + "=" + value;
		}
		return uri;
	};
	
	var getActiveProductURL = function(addIfNotPresentVariationId) {
		var $selectedContext = $('.active-context-js'),
			$selectedSwatch = $('.context-toggle-js:not(.hide) .color-swatches-js .attr-box.selected [data-role="swatch"]'),
			$selectedOption = $('.context-toggle-js:not(.hide) .color-swatches-js .attr-box.selected[data-role="swatch"]'),
			contextProductURL = $selectedContext.data('product-url'),
			swatchProductURL = $selectedSwatch.data('product-url'),
			optionProductURL = $selectedOption.data('product-url'),
			variationID = $selectedSwatch.data('variation-id') || $selectedOption.data('variation-id'),
			// Content URL overrides swatch URL
			url = contextProductURL || swatchProductURL || optionProductURL,
			newURL;
			
		if(url.indexOf('?') >= 0)
			newURL = url + window.location.hash;
		else 
			newURL = url + window.location.search + window.location.hash;
		return updateQueryStringParameter(newURL, 'variationId', variationID, addIfNotPresentVariationId);
	};
	
	$.pubsub('subscribe', 'product-form.attr.swatch.click', function(msg, event){
		// Replace the current URL on a swatch click
		history.replaceState(null, null, getActiveProductURL(WCS_CONFIG.PDP.changeVariationIdOnColorClick));
	});

	$.pubsub('subscribe', 'product-form.attr.context.changed', function(msg, event) {
		// Replace the current URL on a context change
		history.replaceState(null, null, getActiveProductURL());
	});
});
